import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import styled from 'styled-components';

const PageWrapper = styled(Flex)`
  width: 100%;
  padding: 20px;
  flex-direction: column;

  > img {
    width: 40%;
    align-self: flex-end;
  }

  ${Flex} {
    width: calc(100%);
    flex-direction: column;
  }

  ${Button} {
    width: 100%;
  }

  @media ${device.laptop} {
    flex-direction: row;
    > img {
      margin-right: 50px;
      width: 200px;
    }
    ${Button} {
      width: auto;
    }
  }
`;

const Container = styled(Flex).attrs({
  justify: 'center',
  align: 'center',
})`
  width: calc(100% - 50px);
  margin: 100px auto;
  height: calc(100vh - 150px);
  @media ${device.tablet} {
    max-width: 1300px;
    width: calc(100% - 150px);
    margin: 150px auto;
  }
`;

const PostNotFoundContainer = styled(Flex).attrs({
  align: 'center',
  direction: 'column',
})`
  max-width: 375px;
  padding: 20px;
  background: ${color.light};

  img {
    width: 160px;
  }
`;

const ButtonCTA = styled(Button).attrs({
  type: 'primary',
  mt: '28px',
  width: '100%',
})`
  padding: 12px 16px;
  font-family: var(--font-bold);
  border-radius: 4px;
`;

const UserNotFoundContainer = styled(Flex).attrs({
  direction: 'column',
  align: 'center',
  justify: 'center',
})`
  background: #FFFFFF;
  border: 1px solid #DADADA;
  width: 668px;
  padding-top: 62px;
  padding-bottom: 62px;
  border-radius: 2px;
`;

const ButtonBackHome = styled.a`
  padding: 12.5px 16px;
  background: #00AB6B;
  color: #FFFFFF;
  font-weight: bold;
  font-family: var(--font-bold);
  border-radius: 4px;
  margin-top: 40px;

  :active, :hover {
    color: #FFFFFF;
  }
`;

export {
  PageWrapper,
  Container,
  PostNotFoundContainer,
  ButtonCTA,
  UserNotFoundContainer,
  ButtonBackHome,
};
